import {resourcesSliceFactory} from "../../../../setup/redux/slice/resourcesSlice";

export const producersSlice = resourcesSliceFactory('producers');
